var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPdfHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23.22px",
    height: "23px",
    viewBox: "0 0 23.22 23",
    style: {
      enableBackground: "new 0 0 23.22 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#000000;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_275",
    transform: "translate(-1293 -101.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1093",
    x: 1296.56,
    y: 102.5,
    className: "st0",
    width: 18.67,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1094",
    x: 1293,
    y: 109,
    className: "st1",
    width: 16.89,
    height: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_274",
    transform: "translate(1295.15 110.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_189",
    className: "st2",
    d: "M0,0h1.66c1.12,0,1.99,0.39,1.99,1.59c0,1.16-0.87,1.68-1.96,1.68H1.01v1.8H0V0z M1.62,2.47 c0.7,0,1.03-0.29,1.03-0.88S2.29,0.8,1.59,0.8H1.01v1.66H1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    className: "st2",
    d: "M4.46,0h1.39c1.4,0.01,2.53,1.15,2.52,2.55C8.36,3.92,7.27,5.03,5.9,5.07H4.46V0z M5.79,4.25 c0.95,0,1.54-0.51,1.54-1.74s-0.59-1.7-1.54-1.7H5.48v3.45L5.79,4.25L5.79,4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_191",
    className: "st2",
    d: "M9.3,0h3.12v0.84h-2.11v1.32h1.8v0.85h-1.8v2.05H9.3V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPdfHover);
export default __webpack_public_path__ + "static/media/ico_pdf_hover.55643535f58b50d370f5ecabda592e02.svg";
export { ForwardRef as ReactComponent };